<template>
  <b-card no-body class="ml-2 mb-2 text-left"
  style="max-width: 7.5cm; min-width: 7.5cm;">
    <b-row no-gutters>
      <b-col cols="4">
        <b-img fluid style="max-width: 6rem; min-height: 8rem; max-height: 8rem;"
        :src="`https://apps.escoladeltreball.org/orles/get/user/${user.codi_xarxa}`">
        </b-img>
      </b-col>
      <b-col cols="8">
        <b-card-body>
          <font-awesome-icon :icon="['fas', 'times']" class="float-right mt-n2 mr-n2 pointer"
           v-if="editable" @click="removeUser(user.codi_xarxa, user_type)"/>
          <b-card-text>
            <b-row class="mb-2 mt-n1">
              <b-col>
                <b>{{user.nom}} {{ user.cognom1 }}</b>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                Usuari: {{user.codi_xarxa}}
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                Departament: {{user.departament}}
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                Estat: {{user.estat}}
              </b-col>
            </b-row>
          </b-card-text>
        </b-card-body>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>

export default {
  props: {
    user: {
      required: true,
      type: Object
    },
    editable: {
      required: true,
      type: Boolean
    },
    user_type: {
      required: true,
      type: String
    },
    ticket: {
      required: true,
      type: Object
    }
  },
  methods: {
    removeUser (codiXarxa, type) {
      this.$snotify.confirm('Estàs segur/a?', {
        showProgressBar: false,
        closeOnClick: false,
        buttons: [
          {
            text: 'Yes',
            action: (toast) => {
              var data = {
                ticketId: this.ticket.id,
                codi_xarxa: codiXarxa
              }
              if (type === 'User') {
                if (this.ticket.usuaris.length === 1) {
                  this.notifyError('Error', 'Una incidència ha de tenir com a mínim un usuari.')
                } else {
                  this.$store.dispatch('userUnfollowTicket', data)
                }
              } else if (type === 'Manager') {
                this.$store.dispatch('managerUnfollowTicket', data)
              }
              this.$snotify.remove(toast.id)
            },
            bold: false
          },
          {
            text: 'No',
            action: (toast) => {
              this.$snotify.remove(toast.id)
            },
            bold: false
          }
        ]
      })
    }
  }
}
</script>

<style scoped>
.pointer {
  cursor: pointer;
}
</style>
